/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import './AboutUsPage.scss';
import AppHeader from '../../shared/components/app-header/AppHeader';
import { getStringFromLS } from '../../shared/helper-utils/localStorage';
import { APP_USER_AUTH } from '../../saas/AppStorageStaticNames';
import { getStaticPageContent } from '../../api/profileApi';
import { isEmpty } from '../../shared/helper-utils/appUtils';
import AppLoading from '../../shared/components/app-loading/AppLoading';

function AboutUs() {
  const userAuth = getStringFromLS(APP_USER_AUTH);
  const [pageContent, setPageContent] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const getPageContent = async () => {
    setIsLoading(true);
    const res = await getStaticPageContent('about_us');
    if (
      res &&
      res.Root &&
      res.Root.Status === 'OK' &&
      !isEmpty(res.Root.Result) &&
      !isEmpty(res.Root.Result?.StaticContent?.PageContent)
    ) {
      const { PageContent } = res.Root.Result.StaticContent;
      setPageContent(decodeURIComponent(PageContent));
    }
    setIsLoading(false);
  };
  useEffect(() => {
    getPageContent();
  }, []);
  return (
    <>
      {isLoading && <AppLoading isLoading={isLoading} />}
      {(userAuth === null || userAuth === undefined) && <AppHeader />}
      {!isEmpty(pageContent) ? (
        <div
          className="about-us_content"
          dangerouslySetInnerHTML={{ __html: pageContent }}
        />
      ) : (
        <div className="about-us_content">About us</div>
      )}
    </>
  );
}

export default AboutUs;
